import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LanguageService } from '../../core';


/**
 * Base component to share common features in every component.
 */
@Component({
	selector: 'tsp-base',
	template: '',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class BaseComponent {

	protected readonly langSrv = inject(LanguageService);

	labels = computed(() => this.langSrv.labels());

}
